import { HistoryOutlined } from "@ant-design/icons";
import { Row, Col, Typography, Avatar, List, Spin } from "antd";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase/config";
import { useAuthContext } from "../hooks/useAuthContext";

const { Title } = Typography;

export default function LatestUpdates() {
   const [updateData, setUpdateData] = useState([]);
   const [loading, setLoading] = useState(true);

   const user = useAuthContext();

   useEffect(() => {
      //admin update query
      const adminQ = query(collection(db, "latestUpdates"));

      //user query
      const q = query(collection(db, "latestUpdates"), where("adminUpdate", "==", false));

      //checks if user is admin and gets the
      if (user.admin) {
         const unsubscribe = onSnapshot(adminQ, (snapshot) => {
            let results = [];
            snapshot.docs.forEach((doc) => {
               results.push({ ...doc.data(), id: doc.id });
            });

            //sorts array by date
            const sortedArray = results.sort((a, b) => {
               return b.date.toMillis() - a.date.toMillis();
            });

            //updates state
            setUpdateData(sortedArray);

            //sets loading to false
            setLoading(false);
         });
         return () => unsubscribe();
      } else {
         const unsubscribe = onSnapshot(q, (snapshot) => {
            let results = [];
            snapshot.docs.forEach((doc) => {
               results.push({ ...doc.data(), id: doc.id });
            });

            //sorts array by date
            const sortedArray = results.sort((a, b) => {
               return b.date.toMillis() - a.date.toMillis();
            });

            //updates state
            setUpdateData(sortedArray);

            //sets loading to false
            setLoading(false);
         });
         return () => unsubscribe();
      }
   }, [user]);

   // if loading returns a loading state
   if (loading) {
      return (
         <>
            <Row>
               <Col>
                  <Title level={3}>
                     Latest Updates <HistoryOutlined />
                  </Title>
               </Col>
               <Col>
                  <Spin />
               </Col>
            </Row>
         </>
      );
   }

   //returns the update data
   return (
      <div>
         <Row>
            <Col>
               <Title level={3}>
                  Latest Updates <HistoryOutlined />
               </Title>
               {user && user.uid === "a8VctPNqlDPDPCd1k7BhXczYobt2" ? (
                  <>
                     <Link to="/create-update">Create Update</Link>
                  </>
               ) : (
                  ""
               )}
            </Col>
         </Row>

         <List
            style={{ padding: "25px" }}
            itemLayout="vertical"
            dataSource={updateData}
            size="large"
            footer={
               <div>
                  <b>CRAFTIKA CMS</b>
               </div>
            }
            renderItem={(update) => (
               <List.Item key={update.id}>
                  <List.Item.Meta
                     avatar={<Avatar size={40} src={update.userPhoto} />}
                     title={update.mainHeader}
                     description={`Patch notes created in ${moment.unix(update.date.seconds).format("L")} and updated by ${update.userEmail}`}
                  />
                  {update.update.map((item) => (
                     <List.Item.Meta
                        style={{ marginLeft: "10%" }}
                        title={item.header}
                        description={
                           <ul>
                              {item.changes.map((change, idx) => (
                                 <li key={idx}>{change}</li>
                              ))}
                           </ul>
                        }
                     />
                  ))}
               </List.Item>
            )}
         />
      </div>
   );
}
